import { render, staticRenderFns } from "./OfLocationInput.vue?vue&type=template&id=5c99210a&scoped=true"
import script from "./OfLocationInput.vue?vue&type=script&lang=js"
export * from "./OfLocationInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c99210a",
  null
  
)

export default component.exports